import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

/*
 * Item displaying information for the report table
 */ export default function ReportItemQuestionnaire({
  item,
  isOdd,
  allColumns = [],
  groupedHeaders = [],
}) {
  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      <div className={styles.ibo}>{item.IBO}</div>
      <div className={styles.name}>{item.name}</div>
      <div className={styles.attending}>{item.attending}</div>

      {allColumns.map((col, index, arr) => {
        const colWidth = 25 / arr.length;

        const value =
          item.questionColumn === col.name ? item.responseValue : "";

        const isFirstInGroup = groupedHeaders.some(
          (g) => g.columns[0].name === col.name
        );

        return (
          <div
            key={`${col.name}-${index}`}
            className={index % 2 !== 0 ? styles.col : styles.oddCol}
            style={{
              width: `${colWidth}%`,
              textAlign: "center",
              borderLeft: isFirstInGroup ? "1px solid #000" : "none",
            }}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
}

ReportItemQuestionnaire.propTypes = {
  item: PropTypes.object,
  isOdd: PropTypes.bool,
  type: PropTypes.string,
};
